import styled from "styled-components";

export const Contenedor = styled.div`
  margin-top: 5px;
  padding: 25px;
  width: 100%;
  display: grid;
  gap: 10px;
  //background: #eef3f5;
  background: #fff;
  margin: 10px 0;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(129, 129, 129, 0.7);
`;

export const TituloEmpleado = styled.h6`
  color: #fff;
`;
export const TituloCarrito = styled.h4`
  text-align: center;
`;